import ModalWindow from 'components/ModalWindow';
import icon from "assets/img/icons/success-green-big.svg";

const CombineSuccess = ({close}) => {

  return (
    <ModalWindow close={close}>
      <div className="modal-window__wrapper">
        <header className="modal-window__header">
          <img src={icon} className="modal-window__icon" alt="" />
          <h5 className="modal-window__title">Success!</h5>
          <p className="modal-window__info">New cards were added to your inventory</p>
        </header>
        <footer className="modal-window__footer">
          <button className="modal-window__footer-close" onClick={close}>
            Done
          </button>
        </footer>
      </div>
    </ModalWindow>
  );
}

export default CombineSuccess
